export enum ExpensesClassificationTypeClassificationType {
E3_101,
E3_102_001,
E3_102_002,
E3_102_003,
E3_102_004,
E3_102_005,
E3_102_006,
E3_104,
E3_201,
E3_202_001,
E3_202_002,
E3_202_003,
E3_202_004,
E3_202_005,
E3_204,
E3_207,
E3_209,
E3_301,
E3_302_001,
E3_302_002,
E3_302_003,
E3_302_004,
E3_302_005,
E3_304,
E3_307,
E3_309,
E3_312,
E3_313_001,
E3_313_002,
E3_313_003,
E3_313_004,
E3_313_005,
E3_315,
E3_581_001,
E3_581_002,
E3_581_003,
E3_582,
E3_583,
E3_584,
E3_585_001,
E3_585_002,
E3_585_003,
E3_585_004,
E3_585_005,
E3_585_006,
E3_585_007,
E3_585_008,
E3_585_009,
E3_585_010,
E3_585_011,
E3_585_012,
E3_585_013,
E3_585_014,
E3_585_015,
E3_585_016,
E3_586,
E3_587,
E3_588,
E3_589,
E3_882_001,
E3_882_002,
E3_882_003,
E3_882_004,
E3_883_001,
E3_883_002,
E3_883_003,
E3_883_004,
VAT_361,
VAT_362,
VAT_363,
VAT_364,
VAT_365,
VAT_366,
E3_103,
E3_203,
E3_303,
E3_208,
E3_308,
E3_314,
E3_106,
E3_205,
E3_305,
E3_210,
E3_310,
E3_318,
E3_598_002,
}
